import type { InteractionsConfig } from '@wix/thunderbolt-becky-types'

const resolveKey = (key: string, compIdToTemplateCompPath: Record<string, string>): string => {
	const slashIndex = key.indexOf('/')
	if (slashIndex === -1) {
		return compIdToTemplateCompPath[key] ?? key
	}
	const compId = key.slice(0, slashIndex)
	const suffix = key.slice(slashIndex)
	return (compIdToTemplateCompPath[compId] ?? compId) + suffix
}

export const assignCompPathToInteractionsConfig = (
	interactionsConfig: InteractionsConfig,
	compIdToTemplateCompPath: Record<string, string>
): InteractionsConfig => {
	return {
		interactions: interactionsConfig.interactions.map((interaction) => ({
			...interaction,
			key: resolveKey(interaction.key, compIdToTemplateCompPath),
			effects: interaction.effects.map((effect) => ({
				...effect,
				...(effect.key && { key: resolveKey(effect.key, compIdToTemplateCompPath) }),
			})),
		})),
		effects: interactionsConfig.effects,
		...(interactionsConfig.conditions && { conditions: interactionsConfig.conditions }),
	}
}
